import { FormGroup } from '@angular/forms';

export class CheckboxField {
  id?: number;
  label?: string;
  value?: any;
  class?: string;
  containerClass?: string;
  formControlName?: string;
  formGroup?: FormGroup;
  formGroupName?: any;
  tooltip?: any;
  errorMessage?: string;
  fieldFormGroup?: string;
}
